import { useEffect, useState } from "react";

/**
 * Responde a um media query em JS.
 *
 * Serve para o caso em que esconder por CSS não basta: quando os dois lados
 * são CONTROLES DE FORMULÁRIO, o `hidden md:flex` deixa os dois no DOM — com
 * `data-testid` e `id` duplicados, e o leitor de tela anunciando cada filtro
 * duas vezes. Aqui só um dos dois chega a existir.
 */
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(
    () => (typeof window !== "undefined" ? window.matchMedia(query).matches : false),
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
